// extracted by mini-css-extract-plugin
module.exports = {"plugin-version-warnings":"PluginVersionWarningsView_plugin-version-warnings__RYKwJ"};